export default __webpack_public_path__ + "static/media/source.9c0835f3.png";